import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import AddArticleModal from "../modals/AddArticleModal";
import EditArticleModal from "../modals/EditArticleModal";

function AdminDashboard() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedArticleId, setSelectedArticleId] = useState(null);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalArticles, setTotalArticles] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();

  const ITEMS_PER_PAGE = 30;

  // 전체 게시글 수 가져오기
  const fetchTotalArticles = async () => {
    try {
      const response = await axios.get("https://co77iri.com/getTotalArticleNum");
      setTotalArticles(response.data.total);
      setTotalPages(Math.ceil(response.data.total / ITEMS_PER_PAGE));
    } catch (error) {
      console.error("전체 게시글 수 가져오기 실패:", error);
    }
  };

  // 게시글 목록 가져오기 (페이지별)
  const fetchArticles = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(`https://co77iri.com/fetchArticles/${page}`);
      // ID 내림차순으로 정렬 (최신순)
      const sortedArticles = response.data.sort((a, b) => b.id - a.id);
      setArticles(sortedArticles);
    } catch (error) {
      console.error("게시글 목록 가져오기 실패:", error);
    } finally {
      setLoading(false);
    }
  };



  // 모달 열기 함수
  const handleOpenModal = () => {
    console.log("모달 열기 버튼 클릭됨");
    console.log("현재 showAddModal 상태:", showAddModal);
    setShowAddModal(true);
    console.log("showAddModal을 true로 설정함");
  };

  // 수정 모달 열기 함수
  const handleEditModal = (articleId) => {
    setSelectedArticleId(articleId);
    setShowEditModal(true);
  };

  // 삭제 함수
  const handleDelete = async (articleId) => {
    const isConfirmed = window.confirm("정말로 이 게시글을 삭제하시겠습니까?");
    
    if (isConfirmed) {
      try {
        const token = Cookies.get("token");
        const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
        await axios.delete(`https://co77iri.com/deleteArticle/${articleId}`, {
          headers: authHeaders
        });
        alert("게시글이 성공적으로 삭제되었습니다!");
        fetchTotalArticles(); // 전체 게시글 수 새로고침
        fetchArticles(currentPage); // 현재 페이지 새로고침
      } catch (error) {
        console.error("게시글 삭제 실패:", error);
        alert("게시글 삭제에 실패했습니다.");
      }
    }
  };



  // 페이지 변경
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchArticles(page);
  };

  // 페이지네이션 컴포넌트
  const Pagination = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return (
      <div className="flex items-center justify-center space-x-2 mt-6">
        {/* 이전 페이지 */}
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          이전
        </button>

        {/* 페이지 번호들 */}
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => handlePageChange(page)}
            className={`px-3 py-2 text-sm font-medium rounded-md ${
              currentPage === page
                ? "bg-blue-600 text-white"
                : "text-gray-500 bg-white border border-gray-300 hover:bg-gray-50"
            }`}
          >
            {page}
          </button>
        ))}

        {/* 다음 페이지 */}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          다음
        </button>
      </div>
    );
  };

  useEffect(() => {
    fetchTotalArticles();
    fetchArticles(1);
  }, []);



  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-xl">로딩 중...</p>
      </div>
    );
  }

  return (
    <div className="2xl:w-[80%] w-[95%] mx-auto p-6">
      {/* 헤더 */}
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">관리자 대시보드</h1>
      </div>

      {/* 게시글 추가 버튼 */}
      <div className="mb-6">
        <button
          onClick={handleOpenModal}
          className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 font-semibold"
        >
          + 새 게시글 추가
        </button>
      </div>

      {/* 게시글 정보 */}
      <div className="mb-4 text-sm text-gray-600">
        총 {totalArticles}개의 게시글 (페이지 {currentPage} / {totalPages})
      </div>

      {/* 게시글 목록 */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="px-6 py-4 bg-gray-50 border-b">
          <h2 className="text-xl font-semibold">게시글 목록</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  분류
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  제목
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  작성일
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  관리
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {articles.map((article) => (
                <tr key={article.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {article.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {article.category}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {article.title}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {new Date(article.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <button 
                      onClick={() => handleEditModal(article.id)}
                      className="text-indigo-600 hover:text-indigo-900 mr-3"
                    >
                      수정
                    </button>
                    <button 
                      onClick={() => handleDelete(article.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      삭제
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 페이지네이션 */}
      {totalPages > 1 && <Pagination />}

      {/* 게시글 추가 모달 */}
      {showAddModal && (
        <AddArticleModal
          isOpen={showAddModal}
          onClose={() => setShowAddModal(false)}
          onSuccess={() => {
            setShowAddModal(false);
            fetchTotalArticles(); // 전체 게시글 수 새로고침
            fetchArticles(currentPage); // 현재 페이지 새로고침
          }}
        />
      )}

      {/* 게시글 수정 모달 */}
      {showEditModal && (
        <EditArticleModal
          isOpen={showEditModal}
          onClose={() => {
            setShowEditModal(false);
            setSelectedArticleId(null);
          }}
          onSuccess={() => {
            setShowEditModal(false);
            setSelectedArticleId(null);
            fetchTotalArticles(); // 전체 게시글 수 새로고침
            fetchArticles(currentPage); // 현재 페이지 새로고침
          }}
          articleId={selectedArticleId}
        />
      )}
    </div>
  );
}

export default AdminDashboard; 